import { _mediaHeaders } from 'projectSpecific/sports/helpers/sportsEnums'
import { ammendTeamName } from 'projectSpecific/sports/helpers/teams'
import React from 'react'

export const ammendMedia_results = (callData, date, result) => {
  if (!result) return []

  const {
    _useSingleDate,
    singleDate,
    singleDates,
  } = callData

  const doc = new DOMParser().parseFromString(result, 'text/html')
  const table = doc.querySelector('table.schedule')

  if (!table) return []

  const trs = table.querySelectorAll('tr')
  const matchData = []

  // 🔑 explicit state — no DOM guessing
  // let currentLevel = null
  // let currentSection = null
  // let currentSpecial = null

  trs.forEach(tr => {

    const matchAttributes = {
      level: null,
      section: null,
      special: null
    }

    // header rows
    if (tr.classList.contains('class-name')) {
      matchAttributes.level = tr.textContent.trim()
      // currentLevel = tr.textContent.trim()
      // currentSection = null
      // currentSpecial = null
      // Class 6A
      return
    }

    if (tr.classList.contains('conference-name')) {
      // currentSection = tr.textContent.trim()
      matchAttributes.section = tr.textContent.trim()
      // Non Conference
      // Tournaments
      // Section 1 (1A)
      // Non Conference
      return
    }

    if (tr.classList.contains('special-game')) {
      matchAttributes.special = tr.textContent.trim()
      // currentSpecial = tr.textContent.trim()
      // Tournament: Shootout at St. Vincent College
      return
    }

    const tds = tr.querySelectorAll('td')
    if (tds.length !== 3) return

    // const _header = {
    //   ...(currentLevel && { level: currentLevel }),
    //   ...(currentSection && { section: currentSection }),
    //   ...(currentSpecial && { special: currentSpecial })
    // }

    const m = getMediaMatch(tds, date, matchAttributes)

    if (_useSingleDate && m?.startDate === singleDate) {
      console.log('match', m)
    }

    if (_useSingleDate && !_.isEmpty(singleDates) && _.includes(singleDates, m?.startDate)) {
      console.log('match', m)
    }

    if (m) {
      matchData.push(m)
    }
  })

  return matchData
}

const getMediaMatch = (tds, date, matchAttributes) => {

  const _lsp = {
    _matchCollectionKey: _mediaHeaders.tbd,
    level: _mediaHeaders.tbd,
    section: _mediaHeaders.tbd,
    playoff: null,
    playoffBracketType: null,
    _exclude: false
  }

  const m = { startDate: date, _header: matchAttributes }

  //   const matchAttributes = {
  //   level: null,
  //   section: null,
  //   special: null
  // }

  const { level, section, special } = matchAttributes

  if (special) {

    // level   
    // Class 6A

    // section
    // Non Conference
    // Tournaments
    // Section 1 (1A)
    // Non Conference

    // special 
    // Tournament: Shootout at St. Vincent College

    const isTournament = special && special.includes('Tournament') && section && section.includes('Tournament')

    if (isTournament) {
      _lsp._matchCollectionKey = _mediaHeaders.tournament
      _lsp.level = _mediaHeaders.tournament
      _lsp.section = _mediaHeaders.tournament
    } else {
      const { sportLevel, isWpial, playoffBracketType } = getPlayoffLevelFromText(special)
      if (isWpial && sportLevel) {
        _lsp.level = sportLevel
        _lsp.section = _mediaHeaders.nonSection
        _lsp.playoffBracketType = playoffBracketType
        _lsp.playoff = playoffBracketType ? true : false
      } else {
        _lsp._exclude = true
      }
    }
  }

  if (level && !special) {
    switch (level) {
      case 'Playoffs':
        _lsp.playoff = true
        break;
      default:
        _lsp.level = getLevelFromText(level)
      // nothing
    }
  }

  if (section && !_lsp.section) {
    switch (section) {
      case 'Non Conference':
        _lsp.level = _mediaHeaders.tbd
        _lsp.section = _mediaHeaders.nonSection
        break;
      case 'Tournament':
      case 'Tournaments':
        // nothing - already set above
        break;
      default:
        _lsp.section = section.replace('(' + _lsp.level + ')', '').trim()
    }
  }

  m._lsp = _lsp

  const teamSplit = _lsp.playoff ? ' vs ' : ' at '

  const startTime = tds[0] ? tds[0].textContent : '7:00 PM'
  const _teams = tds[1] ? tds[1].textContent : null
  const _teams_s = _teams.split(teamSplit)

  let homeName
  let awayName;
  let locationName;

  if (_teams_s.length === 2) {
    awayName = _teams_s[0]
    let _home = _teams_s[1]
    if (_lsp.playoff) {
      const homeSplit = _home.split(' at ')
      homeName = homeSplit[0]
      locationName = homeSplit[1]
    } else {
      homeName = _teams_s[1]
    }

    homeName = ammendTeamName(homeName)
    awayName = ammendTeamName(awayName)

    m.away = awayName
    m.home = homeName

    m._matchCollectionKey = _lsp._matchCollectionKey
    m.sections = _lsp.section
    m.levels = _lsp.level

    m.startTime = startTime

    if (_lsp.playoff) {
      m.isPlayoff = true
      m.roundKey = 'playoffs'
      if (_lsp.playoffBracketType) {
        m.poolKey = _lsp.playoffBracketType
      }
    }

    // ammendMatchLevelAndSectionByMatchTeams(m, teams, awayName, homeName, locationName)
    const _result = tds[1] ? tds[2].textContent.trim() : null

    if (_result) {
      if (_result === 'PPD') {
        return null
      } else {
        ammendResults(m, _result)
      }
    }
  }

  if (m._lsp.level !== m.levels) {
    console.log('mismatch', m)
  }

  return _lsp._exclude ? null : m
}

const ammendResults = (match, result) => {

  const _result_s = result.split('-')
  const _result_ot_s = result.split(' ')

  if (_result_s.length === 2) {
    match.awayScore = _result_s[0].trim()
    match.homeScore = _result_s[1].trim()
    if (_result_ot_s.length === 2 && _result_ot_s[1]) {
      match.extra = _result_ot_s[1]
      match.homeScore = match.homeScore.replace(match.extra, '')
      match.homeScore = match.homeScore.trim()
    }
  }
}

const getLevelFromText = (text) => {
  let sportLevel;
  try {
    _.forEach(_sportLevels, (sl) => {
      if (text.includes(sl)) {
        sportLevel = sl
      }
    })
  } catch (error) {
    console.log('getLevelFromText error', text)
  }
  return sportLevel
}
const getPlayoffLevelFromText = (text) => {

  let sportLevel;
  let isWpial;
  let playoffBracketType;
  try {

    isWpial = text.indexOf('WPIAL') >= 0

    _.forEach(_sportLevels, (sl) => {
      if (text.indexOf(sl) >= 0) {
        sportLevel = sl
      }
    })

    _.forEach(playoffBracketTypes, (pbt) => {
      const _text = text.toLowerCase()
      if (_text.includes(pbt.toLowerCase())) {
        playoffBracketType = pbt
      }
      if (!playoffBracketType && _text.includes('first round')) {
        playoffBracketType = playoffBracketTypes.roundOf16
      }
      if (!playoffBracketType && _text.includes('championship')) {
        playoffBracketType = playoffBracketTypes.finals
      }
      if (!playoffBracketType && _text.includes('consolation')) {
        playoffBracketType = playoffBracketTypes.consolation
      }
      if (!playoffBracketType && _text.includes('preliminary round')) {
        // playoffBracketType = playoffBracketTypes.preliminaryRound
        playoffBracketType = playoffBracketTypes.roundOf32
      }
      if (!playoffBracketType && _text.includes('first round')) {
        // playoffBracketType = playoffBracketTypes.preliminaryRound
        playoffBracketType = playoffBracketTypes.roundOf16
      }
    })
  } catch (error) {
    console.log('getLevelFromText error', text)
  }

  if (!playoffBracketType) {
    console.log('text', text)
  }
  return { sportLevel, isWpial, playoffBracketType }
}